import React, { useEffect, useState } from 'react'
import RatingStars from '../../common/RatingStars'
import GetAvgRating from '../../../utils/avgRating';
import { Link } from 'react-router-dom';

const Course_Card = ({course, Height}) => {

    const [avgReviewCount, setAvgReviewCount] = useState(0);

    useEffect(()=> {
        const count = GetAvgRating(course.ratingAndReviews);
        setAvgReviewCount(count);
    },[course])


    
  return (
    <div className=' mb-4 hover:scale-[1.03] transition-all duration-200 z-50 '>
        <Link to={`/courses/${course._id}`}>
            <div>
                <div>
                    <img 
                        src={course?.thumbnail}
                        alt='course thumbnail'
                        className={`${Height}  rounded-xl object-cover`}
                    />
                </div>
                <div className='flex flex-col gap-2 px-1 py-3'>
                    <p className='text-sm font-medium text-richblack-900 md:text-xl'>{course?.courseName}</p>
                    <p className='text-[12px] text-richblack-600 md:text-lg'>By <span className='font-medium text-caribbeangreen-200'>{course?.instructor?.firstName} {course?.instructor?.lastName}</span></p>
                    <div className='flex flex-wrap items-center gap-x-3 gap-y-1'>
                        <span className='font-medium text-caribbeangreen-200'>{avgReviewCount || 0}</span>
                        <RatingStars Review_Count={avgReviewCount} />
                        <span className='hidden text-richblack-600 md:block md:text-lg'>{course?.ratingAndReviews?.length} Ratings</span>
                    </div>
                    <p className='text-sm font-semibold text-richblack-900 md:text-xl'>Rs. {course?.price}</p>
                </div>
            </div>
        </Link>

      
    </div>
  )
}

export default Course_Card
